import React, { useContext, useEffect, useState } from "react";
import PageTitle from "../../atoms/PageTitle";
import MyMaorLayout from "../../templates/MyMaorLayout";
import { APPLICATION_ROUTES, COOKIES, PAGE_TITLES } from "../../../constants";

import cs from "classnames";
import classes from "./WritingCompetition.module.scss";
import CharacterSubmissionItem from "./components/CharacterSubmissionItem";
import VideoSubmissionItem from "./components/VideoSubmissionItem";
import liveGif from "../../../assets/gifs/live.gif";
// import ProgressBar from "./components/ProgressBar";
import maorLogo from "../../../assets/images/my-maor-new-logo.png";
import maorIcon from "../../../assets/images/writing-competition-logo.png";
import NewProgressBar from "./components/NewProgressBar";
import ToichenOptions from "./components/ToichenOptions";
import { isMobile } from "react-device-detect";
import playIcon from "../../../assets/images/competition-play.png";
import Player from "../../organisms/Player";
import Modal from "../../organisms/Modal";
import { useModal } from "../../../hooks";
import Popup from "../../atoms/Popup";
import CompetitionLogInModal from "./components/CompetitionLogInModal";
import { StoreContext } from "../../../contexts";
import { ACTIONS } from "../../../store";
import Loader from "../../atoms/Loader";
import { observer } from "mobx-react-lite";
import {
  useHistory,
  useParams,
} from "react-router-dom/cjs/react-router-dom";
import WinnerItem from "./components/WinnerItem";
import ribbon from "../../../assets/images/yellow-ribbon.png";
import WritingCompetitionIntro from "./components/WritingCompetitionIntro/WritingCompetitionIntro";
import HowDoesItWork from "./components/HowDoesItWork/HowDoesItWork";
import Cookies from "../../../utilities/cookies";
import howItWorksIcon from "../../../assets/images/play-comp.webp";
import SearchBar from "./components/SearchBar";

const submissionColors = [
  "#87BA48",
  "#FFDE59",
  "#FF666B",
  "#FFAE43",
  "#F472D0",
  "#6EC887",
  "#49BEBC",
  "#B29367",
  "#0097B2",
];

export const stageColors = {
  "Character Building": "#d755b3", // Greenish
  "Script Submission": "#87ba48", // Yellow
  Voting: "#49bebc", // Red
  "Award Show": "#FFDE59", // Orange
};

export const stage = {
  CHARACTER_BUILDING: "Character Building",
  SCRIPT_SUBMISSION: "Script Submission",
  VOTING: "Voting",
  AWARD_SHOW: "Award Show",
};

const BUTTON_STATUS = {
  SUBMITTED: "submitted",
  ACCEPTED: "accepted",
  REJECTED: "rejected",
};

export const formatChildNames = (selected_childs) => {
  if (!selected_childs || selected_childs.length === 0) {
    return "Unnamed Character";
  }

  // Group children by last name
  const groupsByLastName = selected_childs.reduce((acc, child) => {
    const lastName = child.last_name || "";
    if (!acc[lastName]) {
      acc[lastName] = [];
    }
    acc[lastName].push(child.first_name);
    return acc;
  }, {});

  // Build a label per last-name group: "Chani and Baila Cohen"
  const groupLabels = Object.entries(groupsByLastName)
    .map(([lastName, firstNames]) => {
      if (!firstNames || firstNames.length === 0) {
        return "";
      }

      const firstNamesPart =
        firstNames.length === 1
          ? firstNames[0]
          : `${firstNames.slice(0, -1).join(", ")} and ${firstNames[firstNames.length - 1]
          }`;

      // When lastName is empty, just return the first names
      return lastName ? `${firstNamesPart} ${lastName}`.trim() : firstNamesPart;
    })
    .filter(Boolean);

  if (groupLabels.length === 1) {
    // Only one last-name group
    return groupLabels[0];
  }

  // Join multiple groups: "Chani and Baila Cohen, Rivky and Sara Friedman"
  return `${groupLabels.slice(0, -1).join(", ")} and ${groupLabels[groupLabels.length - 1]
    }`;
};

export const getFirstChildLocation = (children) => {
  if (!Array.isArray(children) || children.length === 0) {
    return "No children available.";
  }

  const firstChild = children[0]; // Get the first child object
  const { city, state, country } = firstChild;

  // Filter out null/undefined/empty values and join them with commas
  return [city, state, country].filter(Boolean).join(", ");
};

// Helper function to check if a submission matches the search term
export const matchesSearchTerm = (submission, searchTerm) => {
  if (!searchTerm || !searchTerm.trim()) {
    return true;
  }

  const searchLower = searchTerm.toLowerCase().trim();
  const selectedChilds = submission?.selected_childs || [];

  // Check if submission.id matches
  const submissionIdMatch = submission?.id
    ? String(submission.id).toLowerCase().includes(searchLower)
    : false;

  // Check if any child's first name or last name matches
  const childNameMatch = selectedChilds.some((child) => {
    const firstName = (child.first_name || "").toLowerCase();
    const lastName = (child.last_name || "").toLowerCase();
    const fullName = `${firstName} ${lastName}`.trim();

    return (
      firstName.includes(searchLower) ||
      lastName.includes(searchLower) ||
      fullName.includes(searchLower)
    );
  });

  return submissionIdMatch || childNameMatch;
};

export const WRITING_COMPETITON_DATA_KEY = "writingCompetitionData";

const WritingCompetition = observer(() => {
  const [isWinnerViderPlaying, setIsWinnerVideoPlaying] = useState(false); // Video playback state
  const [searchTerm, setSearchTerm] = useState(""); // Single search term for all submissions
  const [highlightedVideo, setHighlightedVideo] = useState(null); // Video matched from URL id
  const [highlightedCharacter, setHighlightedCharacter] = useState(null); // Character matched from URL id
  const history = useHistory();
  const { id: routeId } = useParams();
  const { authorization, writingcompetition, common } =
    useContext(StoreContext);
  const [currentCharacter, setCurrentCharacter] = useState(null);

  console.log("routeId", routeId);

  const welcomeModal = useModal();
  const howItWorksModal = useModal();
  const writingCompetitionData = common.get(WRITING_COMPETITON_DATA_KEY);
  const winnerVideo = writingCompetitionData?.details?.winner_video;
  const winnerVideoImage = writingCompetitionData?.details?.winner_video_image;
  const hasWinnerVideo =
    typeof winnerVideo === "string"
      ? winnerVideo.trim().length > 0
      : Boolean(winnerVideo);

  const handleWelcomeModal = () => {
    welcomeModal.onOpen();
  };

  const handleHowItworksModal = () => {
    howItWorksModal.onOpen();
  };

  const getAction = ACTIONS.WRITING_COMPETITON.GET;

  useEffect(() => {
    const jwt = Cookies.get({ name: COOKIES.AUTHORIZATION });
    if (jwt) {
      if (
        authorization[`success${ACTIONS.AUTHORIZATION.RESIGN_IN}`] ||
        authorization[`success${ACTIONS.AUTHORIZATION.SIGN_IN}`] ||
        authorization.isAuthenticated
      ) {
        writingcompetition[`${getAction}`](authorization.isAuthenticated);
      }
    }
  }, [
    authorization.isAuthenticated,
    // authorization[`success${ACTIONS.AUTHORIZATION.RESIGN_IN}`],
    // authorization[`success${ACTIONS.AUTHORIZATION.SIGN_IN}`],
  ]);

  useEffect(() => {
    const jwt = Cookies.get({ name: COOKIES.AUTHORIZATION });

    if (!jwt) {
      writingcompetition[`${getAction}`]();
    }
  }, [authorization.isAuthenticated]);

  useEffect(() => {
    if (writingcompetition.data) {
      common.set(WRITING_COMPETITON_DATA_KEY, writingcompetition.data);
    }
  }, [writingcompetition.data, writingcompetition[`isLoading${getAction}`]]);

  // Fetch voting threshold when stage is Voting (initial call)
  useEffect(() => {
    if (
      writingCompetitionData?.details?.stage === "Voting" &&
      !writingcompetition.votingThreshold &&
      !writingcompetition[`isLoading${ACTIONS.WRITING_COMPETITON.GET_VOTING_THRESHOLD}`]
    ) {
      writingcompetition[ACTIONS.WRITING_COMPETITON.GET_VOTING_THRESHOLD]();
    }
  }, [
    writingCompetitionData?.details?.stage,
    writingcompetition.votingThreshold,
    writingcompetition[`isLoading${ACTIONS.WRITING_COMPETITON.GET_VOTING_THRESHOLD}`],
  ]);

  // Poll voting threshold API every 10 seconds - only call after previous response is received
  useEffect(() => {
    let intervalId;

    // Only poll if stage is Voting
    if (writingCompetitionData?.details?.stage !== "Voting") {
      return;
    }

    const pollVotingThreshold = () => {
      // Only call if not currently loading
      if (!writingcompetition[`isLoading${ACTIONS.WRITING_COMPETITON.GET_VOTING_THRESHOLD}`]) {
        writingcompetition[ACTIONS.WRITING_COMPETITON.GET_VOTING_THRESHOLD]();
      }
    };

    // Set up interval to poll every 10 seconds
    intervalId = setInterval(pollVotingThreshold, 10000);

    // Cleanup interval on unmount or when stage changes
    return () => {
      if (intervalId) {
        clearInterval(intervalId);
      }
    };
  }, [
    writingCompetitionData?.details?.stage,
    writingcompetition[`isLoading${ACTIONS.WRITING_COMPETITON.GET_VOTING_THRESHOLD}`],
  ]);


  const handleCharacterClick = (character) => {
    setCurrentCharacter(character);
  };

  useEffect(() => {
    common.set("currentCharacter", currentCharacter);
  }, [currentCharacter]);

  // When URL is /writing-competition/c{id} (e.g. c51) and stage is Script Submission or Voting,
  // find that video submission and highlight it. For Character Building stage, find character.
  // Ignore plain numeric ids like /51.
  useEffect(() => {
    if (!routeId) {
      setHighlightedVideo(null);
      setHighlightedCharacter(null);
      return;
    }

    // Only handle ids that start with "c" or "C"
    const firstChar = String(routeId).charAt(0).toLowerCase();
    if (firstChar !== "c") {
      setHighlightedVideo(null);
      setHighlightedCharacter(null);
      return;
    }

    // Extract numeric part after "c" and validate it
    const numericPart = String(routeId).slice(1);
    if (!numericPart || !/^\d+$/.test(numericPart)) {
      setHighlightedVideo(null);
      setHighlightedCharacter(null);
      return;
    }

    const currentStage = writingCompetitionData?.details?.stage;

    // Handle video submissions for Script Submission or Voting stages
    if (currentStage === "Script Submission" || currentStage === "Voting") {
      const allVideos = [
        ...(writingCompetitionData?.video_submissions_on_stage || []),
        ...(writingCompetitionData?.video_submissions || []),
      ];

      const match = allVideos.find(
        (submission) => String(submission?.id) === numericPart
      );

      setHighlightedVideo(match || null);
      setHighlightedCharacter(null);
      return;
    }

    // Handle character submissions for Character Building stage
    if (currentStage === "Character Building") {
      const allCharacters = writingCompetitionData?.character_submissions || [];

      const match = allCharacters.find(
        (submission) => String(submission?.id) === numericPart
      );

      setHighlightedCharacter(match || null);
      setHighlightedVideo(null);
      return;
    }

    // For other stages, clear both
    setHighlightedVideo(null);
    setHighlightedCharacter(null);
  }, [
    routeId,
    writingCompetitionData?.details?.stage,
    writingCompetitionData?.video_submissions_on_stage,
    writingCompetitionData?.video_submissions,
    writingCompetitionData?.character_submissions,
  ]);

  // Scroll to the highlighted video once it exists
  useEffect(() => {
    if (!highlightedVideo) return;

    const timer = setTimeout(() => {
      const el = document.getElementById("highlighted-video");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 400);

    return () => clearTimeout(timer);
  }, [highlightedVideo]);

  // Scroll to the highlighted character once it exists
  useEffect(() => {
    if (!highlightedCharacter) return;

    const timer = setTimeout(() => {
      const el = document.getElementById("highlighted-character");
      if (el) {
        el.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    }, 400);

    return () => clearTimeout(timer);
  }, [highlightedCharacter]);

  const onScrollToVideoSection = () => {
    document
      .querySelector("#scriptSubmission")
      .scrollIntoView({ behavior: "smooth" });
  };

  return (
    <>
      <PageTitle value={PAGE_TITLES.WRITINNG_COMPETITION} />
      <MyMaorLayout>
        <div className={classes.root}>
          <div className={cs(classes.bannerContainer)}>
            <div
              onClick={() => {
                history.push(APPLICATION_ROUTES.ARCHIVED_SUBMISSIONS);
              }}
              className={cs(
                classes.archiveCard,
                classes.grandstanderFamily,
                classes.archiveCardMobile
              )}
            >
              Archived
            </div>
            <div className={cs(classes.bannerRight)}>
              <img
                src={maorLogo}
                alt="maorLogo"
                className={cs(classes.maorLogo)}
              />
              <img
                src={liveGif}
                alt="liveGif"
                className={cs(classes.liveGif)}
              />
            </div>
            <div className={cs(classes.bannerCenter)}>
              <img
                src={maorIcon}
                alt="maorIcon"
                className={cs(classes.maorCompetitionLogo)}
              />
            </div>
            <div className={cs(classes.bannerLeft)}>
              <div
                onClick={() => {
                  history.push(APPLICATION_ROUTES.ARCHIVED_SUBMISSIONS);
                }}
                className={cs(
                  classes.archiveCard,
                  classes.grandstanderFamily,
                  classes.archiveCardDesktop
                )}
              >
                Archived
              </div>
            </div>
          </div>

          {writingcompetition[`isLoading${getAction}`] ||
            authorization[`isLoading${ACTIONS.AUTHORIZATION.RESIGN_IN}`] ||
            authorization[`isLoading${ACTIONS.AUTHORIZATION.SIGN_IN}`] ? (
            <div className="wrapper-vertical-m">
              <Loader />
            </div>
          ) : (
            <div>
              <div className={cs(classes.characterFormTop, "wrapper-m")}>
                <div className="pb-02">
                  <div
                    onClick={handleHowItworksModal}
                    className={cs(
                      classes.competitionCardMobile,
                      classes.grandstanderFamily,
                      "mb-10"
                    )}
                  >
                    <img src={howItWorksIcon} alt="How does the competition work?" className={cs(classes.howItWorksIcon)} />
                    How does the competition work?
                  </div>
                </div>
                <NewProgressBar />
              </div>
              <div className="wrapper-m">
                <div className={cs(classes.progressContainer)}></div>
                <WritingCompetitionIntro
                  writingCompetitionData={writingCompetitionData}
                  authorization={authorization}
                  history={history}
                  isMobile={isMobile}
                  stage={stage}
                  stageColors={stageColors}
                  playIcon={playIcon}
                  APPLICATION_ROUTES={APPLICATION_ROUTES}
                  BUTTON_STATUS={BUTTON_STATUS}
                  onScrollToVideoSection={onScrollToVideoSection}
                />
              </div>

              {writingCompetitionData?.details?.stage == "Character Building" &&
                writingCompetitionData?.details?.toichen_buttons && (
                  <div className="wrapper-m mt-13">
                    <ToichenOptions />
                  </div>
                )}

              <div className="wrapper-vertical-m">
                {writingCompetitionData?.details?.stage === "Award Show" && (
                  <div
                    className={cs(
                      classes.winnerContainer,
                      "wrapper-vertical-m"
                    )}
                  >
                    {!writingCompetitionData?.details?.is_winner_selected && (
                      <div className={cs(classes.winnerOverlay)}>
                        <div className={cs(classes.ribbonContainer)}>
                          <p> STAY TUNED FOR </p>
                          <img
                            className={cs(classes.ribbonImage)}
                            src={ribbon}
                            alt="Ribbon"
                          />

                          <p className={cs(classes.mlLess)}>
                            {" "}
                            THE WINNERS VIDEO{" "}
                          </p>
                        </div>
                      </div>
                    )}
                    <h2
                      className={cs(
                        classes.submissionHeader,
                        classes.grandstanderFamily
                      )}
                    >
                      <span
                        className={cs(
                          classes.submissionHeaderText,
                          classes.red,
                          classes.bgYellow
                        )}
                      >
                        WINNING VIDEO
                      </span>
                    </h2>
                    <div className={cs(classes.winnerContent, "wrapper-m")}>
                      <WinnerItem
                        script={
                          writingCompetitionData?.details?.selected_winner
                        }
                        winner_photo={
                          writingCompetitionData?.details?.winner_photo
                        }
                      />
                      <div
                        className={cs(classes.videoContainer)}
                        style={{ backgroundColor: "#ffd52d" }}
                      >
                        {hasWinnerVideo ? (
                          !isWinnerViderPlaying ? (
                            <div
                              className={cs(classes.winnerVideoContent)}
                              style={{
                                backgroundImage: `url(${writingCompetitionData?.details?.winner_video_thumbnail})`,
                              }}
                            >
                              <button
                                className={cs(classes.playButton)}
                                onClick={() => {
                                  setIsWinnerVideoPlaying(true);
                                }} // Trigger playback on click
                              >
                                <img src={playIcon} alt="Play Icon" />
                              </button>
                            </div>
                          ) : (
                            <Player
                              video={winnerVideo} // Pass the video URL
                              autoplay
                              additionalClass={
                                isMobile ? "mobileHeight" : "desktopHeight"
                              }
                              muted={isMobile ? true : false}
                              playerSize="regularPlayer"
                            />
                          )
                        ) : winnerVideoImage ? (
                          <div
                            className={cs(classes.winnerVideoContent)}
                            style={{
                              backgroundImage: `url(${winnerVideoImage})`,
                            }}
                          />
                        ) : null}
                      </div>
                    </div>
                  </div>
                )}

                <div className="wrapper-m">
                  {/* Single Search Bar for all stages */}
                  {(() => {
                    const hasSubmissions =
                      (writingCompetitionData?.video_submissions_on_stage?.length > 0) ||
                      (writingCompetitionData?.video_submissions?.length > 0) ||
                      (writingCompetitionData?.character_submissions?.length > 0);

                    return hasSubmissions ? (
                      <div className={cs(classes.searchBarContainer, "mb-20")}>
                        <SearchBar
                          placeholder="Search by name"
                          value={searchTerm}
                          onChange={setSearchTerm}
                        />
                      </div>
                    ) : null;
                  })()}


                  {(() => {
                    const isJudgesInSession =
                      writingCompetitionData?.stages?.Voting?.judges_in_session;
                    const showOnStage =
                      (isJudgesInSession && writingCompetitionData?.details?.stage === "Voting") ||
                      writingCompetitionData?.details?.stage === "Award Show";

                    // Filter video_submissions_on_stage based on search term
                    const filteredVideoSubmissionsOnStage =
                      writingCompetitionData?.video_submissions_on_stage?.filter((submission) =>
                        matchesSearchTerm(submission, searchTerm)
                      ) || [];

                    // Show "ON STAGE" when judges are in session and we have video_submissions_on_stage
                    if (
                      showOnStage &&
                      writingCompetitionData?.video_submissions_on_stage?.length > 0
                    ) {
                      return (
                        <div
                          className={cs(classes.SubmissionContainer)}
                          id="scriptSubmission"
                        >
                          <h2
                            className={cs(
                              classes.submissionHeader,
                              classes.grandstanderFamily
                            )}
                          >
                            <span
                              className={cs(
                                classes.submissionHeaderText,
                                classes.red
                              )}
                            >
                              ON STAGE
                            </span>
                            <div className={classes.submissionHeaderLineWrapper}>
                              <div className={classes.submissionHeaderLine}></div>
                            </div>
                          </h2>

                          {filteredVideoSubmissionsOnStage.length > 0 ? (
                            <div
                              className={`${cs(classes.grid)} ${cs(
                                classes.gridSm
                              )} ${cs(classes.gridLg)}`}
                            >
                              {filteredVideoSubmissionsOnStage.map(
                                (script, index) => {
                                  const playerBgColor = submissionColors[index % 9];
                                  return (
                                    <VideoSubmissionItem
                                      key={script.id || index}
                                      script={script}
                                      playerBgColor={playerBgColor}
                                      handleWelcomeModal={handleWelcomeModal}
                                      judgesInSession={true}
                                    />
                                  );
                                }
                              )}
                            </div>
                          ) : searchTerm ? (
                            <div className={cs(classes.noResultsMessage)}>
                              <p>No submissions found matching {searchTerm}</p>
                            </div>
                          ) : null}
                        </div>
                      );
                    }

                    return null;
                  })()}



                  <>
                    {(() => {
                      const isJudgesInSession =
                        writingCompetitionData?.stages?.Voting?.judges_in_session;
                      const isScriptSubmissionOrVotingOrAwardShow =
                        writingCompetitionData?.details?.stage ===
                        "Script Submission" ||
                        writingCompetitionData?.details?.stage === "Voting" ||
                        writingCompetitionData?.details?.stage === "Award Show";

                      // Filter video submissions based on search term
                      const filteredVideoSubmissions =
                        writingCompetitionData?.video_submissions?.filter(
                          (submission) =>
                            matchesSearchTerm(submission, searchTerm)
                        ) || [];

                      if (
                        isScriptSubmissionOrVotingOrAwardShow &&
                        writingCompetitionData?.video_submissions?.length > 0
                      ) {
                        return (
                          <>
                            <div
                              className={cs(
                                classes.SubmissionContainer,
                                (writingCompetitionData?.details?.stage ===
                                  "Award Show" || writingCompetitionData?.details?.stage === "Voting") && writingCompetitionData?.stages?.Voting?.judges_in_session && classes.mtop80
                              )}
                              id="scriptSubmission"
                            >

                              <h2
                                className={cs(
                                  classes.submissionHeader,
                                  classes.grandstanderFamily
                                )}
                              >
                                <span className={cs(classes.submissionHeaderText)}>
                                  {writingCompetitionData?.details?.stage ===
                                    "Voting" &&
                                    !writingCompetitionData?.stages?.Voting
                                      ?.judges_in_session
                                    ? "Voting Booth"
                                    : "Submissions"}
                                </span>
                                <div
                                  className={
                                    classes.submissionHeaderLineWrapper
                                  }
                                >
                                  <div
                                    className={classes.submissionHeaderLine}
                                  ></div>
                                </div>
                              </h2>



                              {/* Section: Result by ID (from route param), shown above regular submissions */}
                              {highlightedVideo && (
                                <div
                                  id="highlighted-video"
                                  className={cs(
                                    classes.highlightedSection
                                  )}
                                >
                                  {/* <h2
                                    className={cs(
                                      classes.submissionHeader,
                                      classes.grandstanderFamily
                                    )}
                                  >
                                    <span className={cs(classes.submissionHeaderText)}>
                                      Submission #{highlightedVideo.id}
                                    </span>
                                    <div
                                      className={classes.submissionHeaderLineWrapper}
                                    >
                                      <div
                                        className={classes.submissionHeaderLine}
                                      ></div>
                                    </div>
                                  </h2> */}

                                  <div className={cs(classes.highlightedSubmission)}>
                                    <VideoSubmissionItem
                                      key={highlightedVideo.id}
                                      script={highlightedVideo}
                                      playerBgColor={submissionColors[0]}
                                      handleWelcomeModal={handleWelcomeModal}
                                      // For highlighted item: show vote button only when Voting is live
                                      judgesInSession={writingCompetitionData?.stages?.Voting?.judges_in_session}
                                    />
                                  </div>

                                  <div
                                    className={classes.highlightedSubmissionHeaderLineWrapper}
                                  >
                                    <div
                                      className={classes.highlightedSubmissionHeaderLine}
                                    ></div>
                                  </div>
                                </div>
                              )}

                              {writingCompetitionData?.details?.stage === "Voting" &&
                                !writingCompetitionData?.stages?.Voting?.judges_in_session &&
                                writingcompetition.votingThreshold?.votes_to_beat !== null && (
                                  <div className={cs(classes.votingThresholdContainer, classes.grandstanderFamily)}>
                                    <span className={cs(classes.votingThresholdText)}>
                                      Votes needed to reach the judges:
                                    </span>
                                    <span className={cs(classes.votingThresholdNumber)}>
                                      {writingcompetition.votingThreshold?.votes_to_beat || 0}
                                    </span>
                                  </div>
                                )}

                              {filteredVideoSubmissions.length > 0 ? (
                                <div
                                  className={`${cs(classes.grid)} ${cs(
                                    classes.gridSm
                                  )} ${cs(classes.gridLg)}`}
                                >
                                  {filteredVideoSubmissions.map(
                                    (script, index) => {
                                      const playerBgColor = submissionColors[index % 9];
                                      return (
                                        <VideoSubmissionItem
                                          key={script.id || index} // Use 'script.id' if available for a unique key
                                          script={script}
                                          playerBgColor={playerBgColor}
                                          handleWelcomeModal={handleWelcomeModal}
                                          judgesInSession={isJudgesInSession}
                                        />
                                      );
                                    }
                                  )}
                                </div>
                              ) : searchTerm ? (
                                <div className={cs(classes.noResultsMessage)}>
                                  <p>No submissions found matching {searchTerm}</p>
                                </div>
                              ) : null}
                            </div>
                          </>
                        )
                      }
                      return null;
                    })()}
                  </>

                  {(writingCompetitionData?.details?.stage ===
                    "Script Submission" ||
                    writingCompetitionData?.details?.stage ===
                    "Character Building") &&
                    writingCompetitionData?.character_submissions?.length > 0 &&
                    (() => {
                      // Filter character submissions based on search term
                      const filteredCharacterSubmissions =
                        writingCompetitionData?.character_submissions?.filter((submission) =>
                          matchesSearchTerm(submission, searchTerm)
                        ) || [];

                      // If we have a highlighted character from the URL, avoid showing it twice
                      const highlightedId = highlightedCharacter?.id;
                      const filteredCharacterSubmissionsWithoutHighlighted =
                        highlightedId
                          ? filteredCharacterSubmissions.filter(
                            (submission) =>
                              String(submission.id) !== String(highlightedId)
                          )
                          : filteredCharacterSubmissions;

                      return (
                        <div
                          className={cs(
                            classes.SubmissionContainer,
                            writingCompetitionData?.details?.stage ===
                            "Script Submission" && "wrapper-vertical-m"
                          )}
                        >
                          <h2
                            className={cs(
                              classes.submissionHeader,
                              classes.grandstanderFamily
                            )}
                          >
                            <span className={cs(classes.submissionHeaderText)}>
                              CHARACTER SUBMISSIONS
                            </span>
                            <div className={classes.submissionHeaderLineWrapper}>
                              <div className={classes.submissionHeaderLine}></div>
                            </div>
                          </h2>

                          {/* Highlighted character from URL (shown above grid) */}
                          {highlightedCharacter && (
                            <div
                              id="highlighted-character"
                              className={cs(
                                classes.highlightedSection
                              )}
                            >
                              <div className={cs(classes.highlightedSubmission)}>
                                <CharacterSubmissionItem
                                  key={highlightedCharacter.id}
                                  character={highlightedCharacter}
                                  bgColor={submissionColors[0]}
                                  onCharacterClick={handleCharacterClick}
                                />
                              </div>

                              <div
                                className={classes.highlightedSubmissionHeaderLineWrapper}
                              >
                                <div
                                  className={classes.highlightedSubmissionHeaderLine}
                                ></div>
                              </div>
                            </div>
                          )}

                          {filteredCharacterSubmissions.length > 0 ? (
                            <div
                              className={`${cs(classes.grid)} ${cs(
                                classes.gridSm
                              )} ${cs(classes.gridM)} ${cs(
                                classes.characterGridLg
                              )}`}
                            >
                              {filteredCharacterSubmissionsWithoutHighlighted.map(
                                (character, index) => {
                                  const bgColor = submissionColors[index % 9];

                                  return (
                                    <CharacterSubmissionItem
                                      key={character.id} // Ensure 'id' is unique
                                      character={character}
                                      bgColor={bgColor}
                                      onCharacterClick={handleCharacterClick}
                                    />
                                  );
                                }
                              )}
                            </div>
                          ) : searchTerm ? (
                            <div className={cs(classes.noResultsMessage)}>
                              <p>No submissions found matching {searchTerm}</p>
                            </div>
                          ) : null}
                        </div>
                      );
                    })()}
                </div>
              </div>
            </div>
          )}
        </div>
      </MyMaorLayout>

      <Modal opened={welcomeModal.isOpened} onClose={welcomeModal.onClose}>
        <Popup
          popup={welcomeModal}
          cardStyles={{
            maxWidth: "600px",
            padding: "50px 40px",
          }}
        >
          <CompetitionLogInModal />
        </Popup>
      </Modal>
      {writingcompetition[`isLoading${getAction}`] ||
        authorization[`isLoading${ACTIONS.AUTHORIZATION.RESIGN_IN}`] ||
        authorization[`isLoading${ACTIONS.AUTHORIZATION.SIGN_IN}`] ? null : (
        <Modal
          opened={howItWorksModal.isOpened}
          onClose={howItWorksModal.onClose}
        >
          <Popup
            popup={howItWorksModal}
            cardStyles={{
              maxWidth: "1140px",
              padding: "40px",
              borderRadius: "30px",
            }}
            overlayStyle={{
              minHeight: "unset",
            }}
          >
            <HowDoesItWork
              url={writingCompetitionData?.how_it_works?.video_url}
              thumbnail={writingCompetitionData?.how_it_works?.thumbnail_url}
            />
          </Popup>
        </Modal>
      )}
    </>
  );
});

export default WritingCompetition;
